import { useState, FC, useEffect } from 'react';
import { useMediaQuery, ListItem, ListItemText, ListItemSecondaryAction, Divider, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { IRoleCategory, IRoleCategoryPart } from '../../../models';
import { Add, Check } from '@mui/icons-material';
import clsx from 'clsx';

interface ICategoryPartListItem {
  category: IRoleCategory;
  parentSetIsAssigned?: any;
  part: IRoleCategoryPart;
  roleCategories: IRoleCategory[];
  setRoleCategories: any;
  setPartIds: any;
  partIds: number[];
  subListIndex: number;
  topLevelIndex: number;
  roles: any;
  roleAssignments: any;
  setRoleAssignments: any;
}

export const CategoryPartListItem: FC<ICategoryPartListItem> = ({ category, parentSetIsAssigned, part, setPartIds, partIds, roles, roleAssignments, setRoleAssignments }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const [isAssigned, setIsAssigned] = useState(part.assigned);
  // const [assignedRoles, setAssignedRoles] = useState<string | null>(part.assignedRoles.length > 0 ? part.assignedRoles.map(role => role.name.trim()).join(', ') : null);
  const isMobile = useMediaQuery('(max-width: 960px)');

  useEffect(() => {
    setIsAssigned(part.assigned);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partIds]);

  useEffect(() => {
    if (part.assigned) {
      part.assignedRoles = roles;
    } else {
      part.assignedRoles = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [part.assigned]);

  return (
    <>
      <ListItem
        button
        classes={{ root: category.subCategories || (category.parts && !category.subCategories) ? classes.listItemWithCats : classes.listItem }}
        onClick={category.subCategories && category.subCategories.length > 0 ? handleClick : null}
      >
        <ListItemText classes={{ root: classes.listItem }} primary={part.name} secondary={part.assignedRoles && part.assignedRoles.map(role => role.name.trim()).join(', ')} />
        <ListItemSecondaryAction className={classes.buttonWrapper}>
          <Button
            color="primary"
            variant={isAssigned ? 'contained' : 'text'}
            startIcon={isAssigned ? <Check /> : <Add />}
            className={category.subCategories ? clsx(classes.editButton, isAssigned && classes.selected) : isAssigned ? classes.selected : undefined}
            onClick={() => {
              // Toggle UI?
              //setIsAssigned(!isAssigned);
              // Toggle being set in data
              if (isAssigned) {
                setPartIds(partIds.filter(id => id !== part.id));
                part.assigned = false;
                let roleAssignmentsCopy = [...roleAssignments];
                for (const assignment of roleAssignmentsCopy) {
                  let partsRemovedFromArray = assignment.approvedPartIds.filter(id => !category.parts.some(part => id === part.id));
                  assignment.approvedPartIds = partsRemovedFromArray;
                }
                setRoleAssignments(roleAssignmentsCopy);
                if (category.parts.every(p => !p.assigned) && category.subCategories.every(sc => !sc.assigned)) {
                  parentSetIsAssigned(false);
                }
              } else {
                setPartIds([...partIds, part.id]);
                let roleAssignmentsCopy = JSON.parse(JSON.stringify(roleAssignments));
                for (const assignment of roleAssignmentsCopy) {
                  assignment.approvedPartIds = [...assignment.approvedPartIds, part.id];
                }
                setRoleAssignments(roleAssignmentsCopy);
                part.assigned = true;
                if (!category.assigned) parentSetIsAssigned(true);
              }
            }}
          >
            {isMobile ? '' : `${isAssigned ? 'Assigned' : 'Assign'}`}
          </Button>
        </ListItemSecondaryAction>
      </ListItem>
      <Divider />
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
    paddingLeft: theme.spacing(4)
  },
  nested: {
    paddingLeft: theme.spacing(4)
  },
  listItem: {
    paddingTop: 2,
    paddingBottom: 2
  },
  listItemWithCats: {
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: theme.spacing(1)
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  editButton: {
    marginRight: 8,
    padding: 0
  },
  openButton: {
    padding: 0
  },
  selected: {
    fontWeight: 'bold',
    padding: `2px 8px`,
    borderRadius: 5,
    marginRight: 0
  }
}));
